<template>
  <mdb-container fluid v-bind:style="{ fontFamily: 'OpenSans-Regular', fontSize: '12px' }">
    <!--Section: Intro-->
    <mdb-row>
      <mdb-col>
        <h2 class="mt-lg-4 mb-1 pb-1" style="font-family: OpenSans-bold">
          <strong>Reporte accesos faciales</strong>
        </h2>
      </mdb-col>
    </mdb-row>

    <!-- Pantalla informativa para fracs sin acceso -->
    <section class="my-5" v-if="!hasFacialRecognition">
      <mdb-card cascade>
        <FeatureUnavailable />
      </mdb-card>
    </section>

    <!--Section: Main panel - Solo visible para fracs con reconocimiento facial-->
    <section class="my-5" v-else>
      <!--Card-->
      <mdb-card cascade>
        <!--Section: Table-->
        <!--Top Table UI-->
        <div class="card card-cascade narrower z-depth-0">
          <!--Card image-->
          <div class="
    view view-cascade
    narrower
    py-2
    mx-4
    mb-3
    d-flex
    justify-content-between
    align-items-center
  " style="
    margin-top: -2.25rem;
    background-color: #67a3cf;
    position: static;
  ">
            <span class="white-text" style="
      font-family: OpenSans-Bold;
      font-size: 16px;
      display: table;
      margin: 0 auto;
    ">Accesos registrados por reconocimiento facial</span>

            <div class="text-right" style="margin-top: -10px; display: flex; float: right;">

              <mdb-popover
                trigger="click"
                placement="bottom"
                :options="{ boundary: 'window' }"
              >
                <!-- Contenido del menú -->
                <div slot="body" class="d-flex flex-column">
                  <mdb-btn
                    size="sm"
                    flat
                    class="text-left"
                    @click="exportFile('xlsx')"
                  >
                    <mdb-icon icon="file-excel" class="mr-2" />
                    Excel (.xlsx)
                  </mdb-btn>

                  <mdb-btn
                    size="sm"
                    flat
                    class="text-left"
                    @click="exportFile('csv')"
                  >
                    <mdb-icon icon="file-alt" class="mr-2" />
                    CSV (.csv)
                  </mdb-btn>
                </div>

                <!-- Botón único -->
                <mdb-btn
                  slot="reference"
                  outline="white"
                  rounded
                  size="sm"
                  class="px-2 style_BTN"
                >
                  <mdb-icon icon="download" />
                </mdb-btn>

              </mdb-popover>

            </div>
          </div>
          <mdb-container>
            <div class="offset" style="overflow: visible;">
              <mdb-tbl class="table-st">
                <mdb-tbl-head class="text-left" responsive>
                  <tr>
                    <th scope="col" style="width: 25%; min-width: 200px; max-width: 25%;">
                      Residente
                      <p>
                        <input type="text" class="inputClass" style="width: 85% !important" v-model="filterValue"
                          placeholder="Buscar residente" />
                      </p>
                    </th>
                    <th scope="col" style="width: 20%; min-width: 150px; max-width: 20%;">
                      Tipo de acceso
                      <p>
                        <model-select :options="actionOptions" v-model="actionModel"
                          class="model-select"
                          :style="actionModel.value === '' ? 'height: 37px; width: 100%; color: #999999;' : 'height: 37px; width: 100%; color: #000000;'"
                          placeholder="Selecciona tipo" @select="getReportOfFacialVisits"></model-select>
                      </p>
                    </th>
                    <th scope="col" style="width: 25%; min-width: 180px; max-width: 25%;">
                      Puerta
                      <p>
                        <model-select :options="gatesList" v-model="gateModel"
                          class="model-select"
                          :style="gateModel.value === '' ? 'height: 37px; width: 100%; color: #999999;' : 'height: 37px; width: 100%; color: #000000;'"
                          placeholder="Selecciona una puerta" @select="getReportOfFacialVisits"></model-select>
                      </p>
                    </th>
                    <th scope="col" style="width: 30%; min-width: 200px; max-width: 30%;">
                      Fecha
                      <p>
                        <input type="text" readonly class="inputClass" style="width: 100% !important"
                          placeholder="Rango de fechas" :value="calendarData.dateRange.start != ''
                            ? calendarData.dateRange.start +
                            ' -- ' +
                            calendarData.dateRange.end
                            : ''
                            " @focus="showModal = true" />
                      </p>
                    </th>
                  </tr>
                </mdb-tbl-head>
                <mdb-tbl-body style="font-size: 8px !important">
                  <tr v-for="(item, index) in visitsList" v-bind:key="index">
                    <!--RESIDENT DATA-->
                    <td v-if="item.resident">
                      <span>{{
                        item.resident.firstName +
                        " " +
                        item.resident.lastName
                      }}</span>
                      <p>
                        <mdb-icon icon="home" class="mt-0" />
                        Número: {{ item.resident.number }}
                      </p>
                    </td>
                    <td v-else>SIN REGISTRO</td>

                    <!--EVENT TYPE-->
                    <td>
                      <div :style="{
                        display: 'inline-block',
                        padding: '4px 12px',
                        borderRadius: '12px',
                        backgroundColor: item.eventType === 'IN' ? '#d4edda' : '#f8d7da',
                        color: item.eventType === 'IN' ? '#155724' : '#721c24',
                        fontWeight: 'bold',
                        fontSize: '11px'
                      }">
                        <mdb-icon :icon="item.eventType === 'IN' ? 'sign-in-alt' : 'sign-out-alt'" class="mt-0" />
                        {{ item.eventType === 'IN' ? 'ENTRADA' : 'SALIDA' }}
                      </div>
                    </td>

                    <!--GATE-->
                    <td v-if="item.gate">
                      <mdb-icon icon="road" class="mt-0" />
                      {{ item.gate.name }}
                    </td>
                    <td v-else>SIN REGISTRO</td>

                    <!--EVENT TIME-->
                    <td v-if="item.eventTime">
                      <span>
                        <mdb-icon icon="calendar-alt" class="mt-0" />
                        {{ formatDate(item.eventTime) }}
                      </span>
                      <p>
                        <mdb-icon icon="clock" class="mt-0" />
                        {{ formatTime(item.eventTime) }}
                      </p>
                    </td>
                    <td v-else>SIN REGISTRO</td>
                  </tr>
                </mdb-tbl-body>
              </mdb-tbl>

              <!-- Componente de Paginación -->
              <Pagination :currentPage="page" :totalPages="numberOfPages" @page-change="goToPage" />
            </div>
          </mdb-container>
        </div>

        <!--Section: Table-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Main panel-->
    <Loader v-show="isLoading" />

    <mdb-modal size="md" :show="showModal" @close="showModal = false">
      <mdb-modal-header class="text-center modal-header-style">
        <mdb-modal-title tag="span" class style="color: #ffffff">Selecciona un rango de fechas</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-3">
        <mdb-row>
          <mdb-col md="12">
            <FunctionalCalendar :configs="calendarConfigs" v-model="calendarData"></FunctionalCalendar>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <div class="text-right mb-1" style="
              display: flex;
              position: relative;
              float: right;
              margin-left: auto;
            ">
            <mdb-btn color="light-green" class="btn-prev Rectngulo-14" @click="cleanDate">Limpiar</mdb-btn>
            <mdb-btn class="btn btn-next btn-color-next Rectngulo-14" @click="catchDate">Filtrar</mdb-btn>
          </div>
        </mdb-row>
      </mdb-modal-body>
    </mdb-modal>
  </mdb-container>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import { mapGetters, mapActions } from "vuex";
import Loader from "../../core/Loader";
import XLSX from "xlsx";
import { FunctionalCalendar } from "vue-functional-calendar";
import { ModelSelect } from "vue-search-select";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbPopover,
  mdbSelect,
  mdbBtn,
  mdbDatePicker,
  mdbTooltip,
  mdbSimpleChart,
  mdbIcon,
  mdbFormInline,
  mdbBadge,
  mdbView,
  mdbLineChart,
  mdbListGroup,
  mdbListGroupItem,
  mdbInput,
  mdbDatatable,
  mdbAvatar,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbTbl,
  mdbTblHead,
  mdbTblBody,
} from "mdbvue";
import Pagination from "@/components/Pagination.vue";
import FeatureUnavailable from "@/core/FeatureUnavailable.vue";

export default {
  name: "FacialVisitsReport",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbPopover,
    mdbSelect,
    mdbBtn,
    mdbDatePicker,
    mdbTooltip,
    mdbSimpleChart,
    mdbIcon,
    mdbFormInline,
    mdbBadge,
    mdbView,
    mdbLineChart,
    mdbListGroup,
    mdbListGroupItem,
    mdbInput,
    mdbDatatable,
    mdbAvatar,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    Loader,
    FunctionalCalendar,
    ModelSelect,
    Pagination,
    FeatureUnavailable,
  },
  data() {
    return {
      showModal: false,
      urlServer: Servers.serverApi,
      visitsList: [],
      perPage: 10,
      calendarData: { dateRange: { start: "", end: "" } },
      calendarConfigs: {
        sundayStart: true,
        dateFormat: "yyyy/mm/dd",
        isModal: false,
        isDateRange: true,
        calendarsCount: 1,
        disabledDates: ["afterToday"],
        dayNames: ["L", "M", "Mi", "J", "V", "S", "D"],
        monthNames: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
        shortMonthNames: [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic",
        ],
      },
      page: 1,
      numberOfPages: 0,
      isLoading: false,
      totalPages: 0,
      totalElements: 0,
      filterValue: "",
      startDate: "",
      endDate: "",
      gatesList: [],
      gateModel: {
        value: "",
        uuid: "",
        text: "Todos"
      },
      actionOptions: [
        { value: "", text: "Todos" },
        { value: "IN", text: "Entrada" },
        { value: "OUT", text: "Salida" }
      ],
      actionModel: {
        value: "",
        text: "Todos"
      },
      searchDebounce: null,
    };
  },
  methods: {
    ...mapActions(["getFacialVisitsReport", "getFacialVisitsExport"]),
    async getGates() {
      let response = await Axios.get(Servers.serverApi + "api/gates", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      });
      this.gatesList = [
        { value: "", uuid: "", text: "Todos" }
      ];
      for (var i = 0; i < response.data.length; i++) {
        var temp = {
          value: response.data[i].idGate,
          uuid: response.data[i].uuid,
          text: response.data[i].name
        };
        this.gatesList.push(temp);
      }
    },
    catchDate() {
      if (
        this.calendarData.dateRange.start != "" &&
        this.calendarData.dateRange.end != ""
      ) {
        this.formatDateRange();
        this.showModal = false;
      } else {
        alert("Falta una fecha");
      }
    },
    cleanDate() {
      this.calendarData = { dateRange: { start: "", end: "" } };
      this.startDate = "";
      this.endDate = "";
      this.showModal = false;
      this.page = 1;
      this.getReportOfFacialVisits();
    },
    formatDateRange() {
      // Convertir fecha de inicio a ISO
      var date1 = new Date(this.calendarData.dateRange.start);
      date1.setHours(0, 0, 0, 0);
      this.startDate = date1.toISOString();

      // Convertir fecha de fin a ISO (final del día)
      var date2 = new Date(this.calendarData.dateRange.end);
      date2.setHours(23, 59, 59, 999);
      this.endDate = date2.toISOString();

      this.page = 1;
      this.getReportOfFacialVisits();
    },

    getActiveTimeZone() {
      return (this.isMe && this.isMe.fracTimeZone) || undefined;
    },

    parseToUTCDate(value) {
      if (value == null) return null;
      if (typeof value === 'number') {
        return value < 1e12 ? new Date(value * 1000) : new Date(value);
      }
      if (typeof value === 'string') {
        let v = value.trim();
        const hasZone = /[zZ]|[+\-]\d{2}:\d{2}$/.test(v);
        if (!hasZone) v += 'Z';
        return new Date(v);
      }
      try { return new Date(value); } catch { return null; }
    },

    formatDate(date) {
      const d = this.parseToUTCDate(date);
      if (!d || isNaN(d)) return '—';
      return new Intl.DateTimeFormat('es-MX', {
        timeZone: this.getActiveTimeZone(),
        day: '2-digit', month: '2-digit', year: 'numeric'
      }).format(d);
    },

    formatTime(date) {
      const d = this.parseToUTCDate(date);
      if (!d || isNaN(d)) return '—';
      return new Intl.DateTimeFormat('es-MX', {
        timeZone: this.getActiveTimeZone(),
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
      }).format(d);
    },

    buildQueryParams() {
      let params = [];
      params.push(`page=${this.page - 1}`); // Backend usa page 0-indexed
      params.push(`size=${this.perPage}`);

      if (this.filterValue) {
        params.push(`filterValue=${encodeURIComponent(this.filterValue)}`);
      }
      if (this.actionModel.value) {
        params.push(`action=${this.actionModel.value}`);
      }
      if (this.gateModel.value) {
        params.push(`gateId=${this.gateModel.value}`);
      }
      if (this.startDate) {
        params.push(`startDate=${encodeURIComponent(this.startDate)}`);
      }
      if (this.endDate) {
        params.push(`endDate=${encodeURIComponent(this.endDate)}`);
      }

      return params.join('&');
    },

    async getReportOfFacialVisits() {
      try {
        this.isLoading = true;
        let params = { query: this.buildQueryParams() };
        let response = await this.getFacialVisitsReport(params);

        if (response.status == 200) {
          this.visitsList = response.data.content || [];
          this.numberOfPages = response.data.totalPages || 0;
          this.totalElements = response.data.totalElements || 0;
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        Swal.fire({
          title: 'Error',
          text: error.response?.data?.message || 'No se pudo obtener el reporte',
          type: 'error',
          confirmButtonText: 'Aceptar',
        });
      }
    },

    makeExcel(list) {
      var newList = [];
      for (let i = 0; i < list.length; i++) {
        let auxJson = {
          residente:
            list[i].resident
              ? list[i].resident.firstName + " " + list[i].resident.lastName + "\nNúmero: " + list[i].resident.number
              : "SIN REGISTRO",
          tipo_acceso:
            list[i].eventType === 'IN' ? 'ENTRADA' : 'SALIDA',
          puerta:
            list[i].gate
              ? list[i].gate.name
              : "SIN REGISTRO",
          fecha:
            list[i].eventTime
              ? this.formatDate(list[i].eventTime) + "\n" + this.formatTime(list[i].eventTime)
              : "SIN REGISTRO",
        };
        newList.push(auxJson);
      }
      return newList;
    },
    exportFile(type) {
      if (type === 'xlsx') {
        this.exportExcel();
      } else {
        this.exportCsv();
      }
    },

    async exportExcel() {
      try {
        this.isLoading = true;

        // Obtener todos los datos sin paginación para exportar
        let params = { query: this.buildQueryParams().replace(/page=\d+&size=\d+/, 'page=0&size=10000') };
        let response = await this.getFacialVisitsExport(params);
        const rows = response.data.content || [];
        if (!rows.length) {
          this.isLoading = false;
          this.showMessageInfo("Sin datos", "No hay datos para descargar", "warning");
          return;
        }

        const dataTransform = this.makeExcel(rows);
        const worksheet = XLSX.utils.json_to_sheet(dataTransform);
        const workbook = XLSX.utils.book_new();
        const fileName = "reporte_accesos_faciales";
        XLSX.utils.book_append_sheet(workbook, worksheet, fileName);
        XLSX.writeFile(workbook, `${fileName}.xlsx`);

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        Swal.fire({
          title: 'Error al exportar',
          text: error.response?.data?.message || 'No se pudo exportar el archivo.',
          type: 'error',
          confirmButtonText: 'Aceptar',
        });
      }
    },

    async exportCsv() {
      try {
        this.isLoading = true;

        let params = { query: this.buildQueryParams().replace(/page=\d+&size=\d+/, 'page=0&size=10000') };
        let response = await this.getFacialVisitsExport(params);

        const rows = response.data.content || [];
        if (!rows.length) {
          this.isLoading = false;
          this.showMessageInfo("Sin datos", "No hay datos para descargar", "warning");
          return;
        }


        const dataTransform = this.makeExcel(rows);
        const worksheet = XLSX.utils.json_to_sheet(dataTransform);
        const csv = XLSX.utils.sheet_to_csv(worksheet);

        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "reporte_accesos_faciales.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        Swal.fire({
          title: 'Error al exportar',
          text: error.response?.data?.message || 'No se pudo exportar el archivo.',
          type: 'error',
          confirmButtonText: 'Aceptar',
        });
      }
    },

    goToPage(pageNumber) {
      this.page = pageNumber;
      this.getReportOfFacialVisits();
    },
    showMessageInfo: function (text, subtitle, type = "warning") {
        Swal.fire({
          title: `<span style="font-size: 20px;">${text}</span>`,
          html: `<span style="font-size: 12px;">${subtitle}</span>`,
          type: type,
          width: "30%",
          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "btn-modal-accept"
          }
        })
      },
  },
  mounted() {
    this.isLoading = true;
    this.getReportOfFacialVisits();
    this.getGates();
  },
  beforeDestroy() {
    // Limpiar timeout al destruir el componente
    if (this.searchDebounce) {
      clearTimeout(this.searchDebounce);
    }
  },
  watch: {
    filterValue() {
      // Limpiar el timeout anterior si existe
      if (this.searchDebounce) {
        clearTimeout(this.searchDebounce);
      }

      // Crear nuevo timeout de 500ms (medio segundo)
      this.searchDebounce = setTimeout(() => {
        this.page = 1;
        this.getReportOfFacialVisits();
      }, 500);
    },
    actionModel: {
      handler() {
        this.page = 1;
        this.getReportOfFacialVisits();
      },
      deep: true
    },
    gateModel: {
      handler() {
        this.page = 1;
        this.getReportOfFacialVisits();
      },
      deep: true
    },
  },
  async created() {
    await this.$store.dispatch("fetchFracCapabilities");
  },
  computed: {
    ...mapGetters({
      isMe: "getWhoAmi",
      hasFacialRecognition: "hasFacialRecognition",
    }),
  },
};
</script>

<style scoped>
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 12px;
  color: #999999;
  opacity: 1;
  /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #999999;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #999999;
}

.table-st {
  border-collapse: collapse !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
  table-layout: fixed !important;
  width: 100% !important;
}

.table>tbody {
  text-align: left;
}

.table td {
  font-size: 10px !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table th {
  overflow: visible;
  position: relative;
}

.table thead {
  overflow: visible;
}

.table thead th p {
  overflow: visible;
}

.table td:nth-child(1),
.table th:nth-child(1) {
  width: 25% !important;
  min-width: 200px !important;
  max-width: 25% !important;
}

.table td:nth-child(2),
.table th:nth-child(2) {
  width: 20% !important;
  min-width: 150px !important;
  max-width: 20% !important;
}

.table td:nth-child(3),
.table th:nth-child(3) {
  width: 25% !important;
  min-width: 180px !important;
  max-width: 25% !important;
}

.table td:nth-child(4),
.table th:nth-child(4) {
  width: 30% !important;
  min-width: 200px !important;
  max-width: 30% !important;
}

.inputClass {
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 1px solid #dadce0;
  border-radius: 4px;
  background-color: transparent;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 2rem;
}

.modal-header-style {
  height: 51.5px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08);
  background-color: #67a3cf;
}

.pagination--active {
  visibility: visible;
  background-color: #67a3cf !important;
}

.modal-content {
  width: 100%;
}

/* Estilo para model-select */
.model-select {
  width: 100%;
  max-width: 100%;
  position: relative;
  z-index: 10;
}

.model-select >>> .form-control {
  color: inherit;
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
}

.model-select >>> input.form-control {
  color: inherit !important;
  width: 100% !important;
}

.model-select >>> .ui.dropdown {
  z-index: 100 !important;
}

.model-select >>> .ui.dropdown .menu {
  z-index: 101 !important;
}

.model-select >>> ul.dropdown-menu {
  z-index: 9999 !important;
  position: absolute !important;
}
</style>
